var _style, _path, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDollar2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 384",
    style: {
      enableBackground: "new 0 0 384 384"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#71A1B7;}\n\t.st1{fill:none;stroke:#71A1B7;stroke-width:40;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,0C86.1,0,0,86.1,0,192c0,105.9,86.1,192,192,192s192-86.1,192-192C384,86.1,297.9,0,192,0z M192,352 c-88.2,0-160-71.8-160-160S103.8,32,192,32s160,71.8,160,160S280.2,352,192,352z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.4,94.4c-2.1-0.9-4.2-1.6-6.4-2.3V64h-32v28.3c-15.2,4.6-28.4,15.6-35.2,31.3c-5.9,13.7-6.2,28.9-0.7,42.9 c5.5,13.9,16.1,24.8,30.2,30.9l31.1,12.6c5.9,2.5,10.4,7.2,12.8,13.2s2.3,12.5-0.3,18.4c-2.5,5.9-7.2,10.4-13.2,12.8 c-6,2.4-12.5,2.3-18.4-0.3c-8.7-3.8-14.3-12.4-14.3-22l0-16l-32,0l0,16c0,22.4,13.2,42.5,33.6,51.4c2.1,0.9,4.2,1.6,6.4,2.3V320h32 v-34.4c1.5-0.5,3-1,4.5-1.5c13.9-5.5,24.8-16.1,30.8-29.8c5.9-13.7,6.2-28.9,0.7-42.8c-5.5-13.9-16.1-24.8-30.2-30.9l-31.1-12.6 c-5.9-2.5-10.4-7.2-12.8-13.2s-2.3-12.5,0.3-18.4c2.5-5.9,7.2-10.4,13.2-12.8c6-2.4,12.5-2.3,18.4,0.3c8.6,3.7,14.3,11.8,14.3,20.2 v16h32v-16C248,122.7,234.8,103.3,214.4,94.4z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 36.5,
    y1: 348,
    x2: 355,
    y2: 29.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDollar2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dollar2.15e166f1.svg";
export { ForwardRef as ReactComponent };